import React from 'react';
import { Link } from 'react-router-dom';
import { getGuideBySlug } from '../content/guides/articles';

function labelFromSlug(slug) {
  return slug
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function GuideRelatedLinks({ relatedGuideSlugs = [], relatedCitySlugs = [], relatedStadiumSlugs = [] }) {
  const guides = (relatedGuideSlugs || []).map((s) => ({ slug: s, g: getGuideBySlug(s) })).filter((x) => x.g);
  const cities = relatedCitySlugs || [];
  const stadiums = relatedStadiumSlugs || [];

  if (!guides.length && !cities.length && !stadiums.length) return null;

  return (
    <section className="mt-12 pt-10 border-t border-gray-200 dark:border-gray-700" aria-labelledby="related-links">
      <h2 id="related-links" className="text-xl font-bold text-gray-900 dark:text-white mb-4">
        Related planning pages
      </h2>
      <ul className="grid sm:grid-cols-2 gap-3 text-sm">
        {guides.map(({ slug, g }) => (
          <li key={slug}>
            <Link to={`/guides/${slug}`} className="text-amber-600 dark:text-amber-400 hover:underline font-medium">
              {g.title}
            </Link>
          </li>
        ))}
        {cities.map((slug) => (
          <li key={`c-${slug}`}>
            <Link to={`/cities/${slug}`} className="text-amber-600 dark:text-amber-400 hover:underline font-medium">
              {labelFromSlug(slug)} fan guide
            </Link>
          </li>
        ))}
        {stadiums.map((slug) => (
          <li key={`s-${slug}`}>
            <Link to={`/stadiums/${slug}`} className="text-amber-600 dark:text-amber-400 hover:underline font-medium">
              {labelFromSlug(slug)}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default GuideRelatedLinks;
